import React from 'react';
import { AuthorisationType } from '../TransactionTypeStep';
import { CompletionScreen } from 'components/PremiumWizard';

const TRANSACTION_TYPE_LABELS: Record<AuthorisationType, string> = {
  WEB_ENQUIRY_AUTOMATION: 'Web flow enquiry lodgement',
  CREATE_ENQUIRY: 'API transactions'
};

interface Props {
  authorisationType: AuthorisationType;
  validUntil: string;
  paymentIntentId: string;
  totalTransactions?: number;
  previousBalance?: number;
  newBalance?: number;
}

const CompletedStep: React.FC<Props> = ({
  authorisationType,
  validUntil,
  paymentIntentId,
  totalTransactions,
  previousBalance,
  newBalance
}) => {
  const transactionTypeLabel = TRANSACTION_TYPE_LABELS[authorisationType];

  return (
    <CompletionScreen
      heading="Transaction purchase complete!"
      bodyText="Your transaction has been successfully purchased and are ready to use."
      stats={[
        {
          label: 'Transaction type',
          value: transactionTypeLabel,
          valueClassName: 'completion-screen-stat-text'
        },
        {
          label: 'Valid until',
          value: validUntil,
          valueClassName: 'completion-screen-stat-text'
        },
        ...(previousBalance === 0
          ? [
              {
                label: 'Total transactions',
                value: String(totalTransactions),
                valueClassName: 'completion-screen-stat-text'
              }
            ]
          : []),
        ...(paymentIntentId
          ? [
              {
                label: 'Transaction reference',
                value: paymentIntentId,
                valueClassName:
                  'completion-screen-stat-text completion-screen-stat-text--success'
              }
            ]
          : [
              {
                label: 'Payment',
                value: 'Invoice will be issued',
                valueClassName:
                  'completion-screen-stat-text completion-screen-stat-text--invoice'
              }
            ])
      ]}
      footerSection={
        previousBalance !== 0 ? (
          <div className="completion-screen--total-section">
            <div className="completion-screen--total-section-row">
              <div className="completion-screen--total-section-row-label">
                Total transactions
              </div>
              <div className="completion-screen--total-section-row-value">
                {totalTransactions}
              </div>
            </div>
            <div className="completion-screen--total-section-row">
              <div className="completion-screen--total-section-row-label">
                Previous balance
              </div>
              <div className="completion-screen--total-section-row-value">
                {previousBalance}
              </div>
            </div>
            <div className="completion-screen--total-section-row">
              <div className="completion-screen--total-section-row-label">
                New balance
              </div>
              <div className="completion-screen--total-section-row-value">
                {newBalance}
              </div>
            </div>
          </div>
        ) : undefined
      }
    />
  );
};

export default CompletedStep;
